module.exports = __webpack_public_path__ + "img/close1.07c34229.png";